import { Check, ChevronRight } from "lucide-react";
import React from "react";
import Shortcuts from "../../../Shortcuts";
import Stack from "../../../Stack";
import { CheckedIndicator } from "../CheckableDropdownMenuItem/styled";
import DropdownMenuItemIconContainer from "../IconContainer";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function Content(_ref) {
  var icon = _ref.icon,
    label = _ref.label,
    checked = _ref.checked,
    shortcut = _ref.shortcut,
    showSubmenuIndicator = _ref.showSubmenuIndicator;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Stack, {
      direction: "horizontal",
      spacing: "sm",
      align: "center",
      children: [checked && /*#__PURE__*/_jsx(CheckedIndicator, {
        children: /*#__PURE__*/_jsx(Check, {
          color: "currentColor"
        })
      }), icon && /*#__PURE__*/_jsx(DropdownMenuItemIconContainer, {
        icon: icon
      }), label]
    }), /*#__PURE__*/_jsxs(Stack, {
      children: [shortcut && /*#__PURE__*/_jsx(Shortcuts, {
        keys: shortcut
      }), showSubmenuIndicator && /*#__PURE__*/_jsx(ChevronRight, {
        color: "currentColor"
      })]
    })]
  });
}
export default Content;